var _path, _path2;
var _excluded = ["alt"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMarineLifeFlag = function SvgMarineLifeFlag(_ref) {
  var alt = _ref.alt,
    props = _objectWithoutProperties(_ref, _excluded);
  var accessibilityProps = alt ? {
    'aria-label': alt,
    role: 'img'
  } : {};
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 29 38"
  }, accessibilityProps, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7E7A69",
    d: "M.633 0C.253 0 0 .253 0 .633v36.734c0 .38.253.633.633.633s.634-.253.634-.633V.633C1.267.253 1.013 0 .633 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#914D9E",
    stroke: "#7E7A69",
    d: "M28.267 2.083V21.35H.767V2.083z"
  })));
};
export { SvgMarineLifeFlag as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAyOSAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNjMzMzM4IDBDMC4yNTMzMzUgMCAwIDAuMjUzMzMzIDAgMC42MzMzMzNWMi41MzMzM1YzNy4zNjY3QzAgMzcuNzQ2NyAwLjI1MzMzNSAzOCAwLjYzMzMzOCAzOEMxLjAxMzM0IDM4IDEuMjY2NjggMzcuNzQ2NyAxLjI2NjY4IDM3LjM2NjdWMi41MzMzM1YwLjYzMzMzM0MxLjI2NjY4IDAuMjUzMzMzIDEuMDEzMzQgMCAwLjYzMzMzOCAwWiIgZmlsbD0iIzdFN0E2OSIvPgo8cGF0aCBkPSJNMjguMjY2NiAyLjA4MzM3VjIxLjM1SDAuNzY2NjAyVjIuMDgzMzdIMjguMjY2NloiIGZpbGw9IiM5MTREOUUiIHN0cm9rZT0iIzdFN0E2OSIvPgo8L3N2Zz4K";